import { HStack } from '@pets-ui/HStack/HStack'
import { Stack } from '@pets-ui/Stack/Stack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  label: {
    padding: '2px 4px',
    borderRadius: 4,
    backgroundColor: colors.grey200,
    fontSize: '10px',
    marginRight: '4px',
  },
})

export interface DetailListProps {
  'id'?: number | string
  'label'?: ReactNode
  'title'?: string
  'discount'?: number
  'currency'?: string
  'data-testid'?: string
}

export const DetailItem = (props: DetailListProps) => {
  const { label, title, discount, 'data-testid': dataTestId } = props
  return (
    <HStack flexWrap="nowrap" justifyContent="space-between" gap={1}>
      <HStack flexWrap="nowrap">
        <Stack alignItems="flex-start"><Text noWrap variant="caption" component="span" rootStyle={styles.label}>{label}</Text></Stack>
        <Text color={colors.grey600} variant="caption" component="span" verticalAlign="middle">{title}</Text>
      </HStack>
      <Stack height="100%" alignItems="flex-start">
        <Text data-testid={dataTestId} color={colors.grey600} noWrap variant="caption">
          -$
          {discount?.toLocaleString() ?? 0}
          {/* {formatCurrency(currency, discount ?? 0)} */}
        </Text>
      </Stack>
    </HStack>
  )
}
